<template>
  <el-container class="layout-container">
    <el-aside width="200px">
      <div class="logo">
        <h2>客户端</h2>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        background-color="#2c3e50"
        text-color="#bfcbd9"
        active-text-color="#ffffff"
        router>
        <el-submenu index="/customer/orders">
          <template slot="title">
            <div class="menu-item-content">
              <i class="el-icon-s-order"></i>
              <span>订单管理</span>
            </div>
          </template>
          <el-menu-item index="/customer/orders/all">
            <div class="menu-item-content">
              <i class="el-icon-tickets"></i>
              <span>所有订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/not-shipped">
            <div class="menu-item-content">
              <i class="el-icon-document"></i>
              <span>未邮寄订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/in-transit">
            <div class="menu-item-content">
              <i class="el-icon-truck"></i>
              <span>在途订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/testing">
            <div class="menu-item-content">
              <i class="el-icon-loading"></i>
              <span>测试中订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/tested">
            <div class="menu-item-content">
              <i class="el-icon-check"></i>
              <span>已测试订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/completed">
            <div class="menu-item-content">
              <i class="el-icon-circle-check"></i>
              <span>已完成订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/expiring">
            <div class="menu-item-content">
              <i class="el-icon-alarm-clock"></i>
              <span>即将/已超期订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/return">
            <div class="menu-item-content">
              <i class="el-icon-back"></i>
              <span>回寄/转寄订单</span>
            </div>
          </el-menu-item>
          <el-menu-item index="/customer/orders/dispute">
            <div class="menu-item-content">
              <i class="el-icon-warning"></i>
              <span>争议/复测订单</span>
            </div>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <div class="header-left">
          <i 
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" 
            @click="toggleSidebar"
          ></i>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/customer/orders/all' }">订单管理</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute.meta && currentRoute.meta.subTitle">
              {{ currentRoute.meta.subTitle }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-user"></i>
              {{ username }} <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.push('/customer/profile')">个人信息</el-dropdown-item>
              <el-dropdown-item @click.native="$router.push('/customer/change-password')">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="handleLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'CustomerLayout',
  data() {
    return {
      isCollapse: false,
      activeMenu: '/customer/orders/all'
    }
  },
  computed: {
    username() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return userInfo.userName || '用户'
    },
    currentRoute() {
      return this.$route
    }
  },
  mounted() {
    // 初始化时确保菜单项高亮
    this.enforceMenuActiveState();
  },
  watch: {
    '$route'(to, from) {
      // 路由变化时保持菜单高亮
      this.$nextTick(() => {
        this.enforceMenuActiveState();
      });
    }
  },
  methods: {
    enforceMenuActiveState() {
      // 不再需要强制设置样式，因为已经在CSS中定义了样式
      this.$nextTick(() => {
        // 计算当前路由与菜单项的匹配度，确保高亮正确的菜单
        this.activeMenu = this.$route.path;
      });
    },
    toggleSidebar() {
      this.isCollapse = !this.isCollapse;
    },
    handleLogout() {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userRole')
        localStorage.removeItem('userInfo')
        this.$router.push('/customer/login')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}
.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2b3c50;
  color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}
.logo h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
}
.el-menu-vertical {
  height: calc(100vh - 60px);
  border-right: none;
  background-color: #2c3e50 !important;
}
.el-menu-vertical .el-submenu__title {
  font-size: 15px;
  height: 56px;
  line-height: 56px;
  padding: 0 20px !important;
  position: relative;
  transition: all 0.3s;
}
.el-menu-vertical .el-submenu__title i {
  color: #bfcbd9;
  font-size: 18px;
  margin-right: 10px;
  width: 24px;
  text-align: center;
  display: inline-block;
}
.el-menu-vertical .el-submenu__title span {
  transition: all 0.3s;
  display: inline-block;
}
.el-menu-vertical .el-submenu__title:hover {
  background-color: #1f2d3d !important;
}
.el-menu-vertical .el-submenu__title:hover i,
.el-menu-vertical .el-submenu__title:hover span {
  color: #ffffff !important;
}
.el-menu-vertical .el-submenu .el-menu {
  background-color: #1f2d3d !important;
}
.el-menu-vertical .el-menu-item {
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  padding: 0 20px 0 40px !important;
  position: relative;
  transition: all 0.3s;
}
.el-menu-vertical .el-menu-item:hover {
  background-color: #283446 !important;
}
.el-menu-vertical .el-menu-item.is-active {
  background-color: #1890ff !important;
  color: #ffffff !important;
}
.menu-item-content {
  display: flex;
  align-items: center;
  height: 100%;
}
.menu-item-content i {
  font-size: 16px;
  margin-right: 10px;
  width: 18px;
  text-align: center;
  color: #bfcbd9;
}
.menu-item-content span {
  font-size: 14px;
  color: #bfcbd9;
}
.el-menu-item.is-active .menu-item-content i,
.el-menu-item.is-active .menu-item-content span {
  color: #ffffff !important;
}
.el-menu-item:hover .menu-item-content i,
.el-menu-item:hover .menu-item-content span {
  color: #ffffff !important;
}
.el-header {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}
.header-left {
  display: flex;
  align-items: center;
}
.header-left i {
  font-size: 20px;
  cursor: pointer;
  margin-right: 15px;
  color: #333;
  transition: all 0.3s;
}
.header-left i:hover {
  color: #1890ff;
  transform: scale(1.1);
}
.el-breadcrumb {
  font-size: 14px;
}
.header-right {
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
}
.el-dropdown-link:hover {
  background-color: #f5f7fa;
}
.el-dropdown-link i.el-icon-user {
  margin-right: 5px;
  font-size: 16px;
  color: #1890ff;
}
.el-main {
  background-color: #f0f2f5;
  padding: 20px;
}
</style> 